// extracted by mini-css-extract-plugin
export default {"mainDiv":"Home_mainDiv__9EsSO","innerDiv":"Home_innerDiv__J51sD","movieDiv":"Home_movieDiv__Ob-Y3"};